import React from 'react';
import { SentryInit } from '@agilize/components-core';
import { render } from 'react-dom';
import App from './App';

if (process.env.NODE_ENV === 'production') {
  SentryInit('https://4dc3c36bed904dcb9af7d0173afc508b@o569786.ingest.sentry.io/5965157', process.env.SENTRY_ENV || 'production');
}
// @ts-ignore
// eslint-disable-next-line camelcase,no-undef
__webpack_public_path__ = process.env.NODE_ENV === 'development' ? __webpack_public_path__ : process.env.APP_PATH;

render(<App />, document.getElementById('app_rh'));
